module.exports = __webpack_public_path__ + "img/logo.4a94aa59.png";